import { Component, OnInit } from '@angular/core';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { UserCustomerService } from '../../../../Services/User/Customer/user-customer.service';
import { NotificationService } from '../../../../Services/notification.service';
import { HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { UsersearchService } from '../../../../Services/User/UserSearch/usersearch.service';
import { AuthService } from '../../../../Services/auth.service';
import { Router } from '@angular/router';
import { GstStaffListComponent } from '../gst-staff-list/gst-staff-list.component';
import { GstAddStaffComponent } from '../gst-add-staff/gst-add-staff.component';
import { GstAdminAccessControlComponent } from '../../Admin/staff-access/gst-admin-access-control.component';

interface Document {
  doc_user_img?: string;
  doc_pan_front_img?: string;
  doc_pan_back_img?: string;
  doc_aadhar_front_img?: string;
  doc_aadhar_back_img?: string;
  [key: string]: any;
}

interface Customer {
  id: number;
  name: string;
  mobilenumber: string;
  gstnumber: string;
  email: string;
  user_customer_type?: string;
  user_trade_name?: string;
  user_last_name?: string;
  billingname?: string;
  doc_user_img?: string;
  documents?: Document[];
}

@Component({
  selector: 'app-gst-customer-list',
  imports: [NgFor, NgIf, NgClass, FormsModule, GstStaffListComponent, GstAddStaffComponent, GstAdminAccessControlComponent],
  templateUrl: './gst-customer-list.component.html',
  styleUrl: './gst-customer-list.component.css'
})
export class GstCustomerListComponent implements OnInit {

  userCustomerList: Customer[] = [];
  fullCustomerList: Customer[] = [];
  isLoadingCustomers = false;
  activeTab = 0;
  selectedCustomerType: string = '';
  customerTypes: string[] = ['Retailer', 'Direct Customer'];

  activeSection: 'customers' | 'staff-list' | 'add-staff' | 'access-control' = 'customers';
  editingStaffId: number | null = null;
  accessControlStaffId: number | null = null;
  isStaff: boolean = false;

  sectionTabs = [
    { id: 'customers', label: 'Customer List' },
    { id: 'staff-list', label: 'Staff List' },
    { id: 'add-staff', label: 'Add Staff' },
  ];

  constructor(
    private userCustomerService: UserCustomerService,
    private notificationService: NotificationService,
    private userSearchService: UsersearchService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isStaff = this.authService.getUserRole() === 'Staff';
    if (this.isStaff) {
      this.sectionTabs = [
        { id: 'customers', label: 'Customer List' }
      ];
    }
    const storedIndex = localStorage.getItem('addCustomerTab');
    const index = storedIndex ? +storedIndex : 0;
    this.activeTab = index >= 0 && index < this.tabs.length ? index : 0;

    this.userSearchService.searchText$.subscribe(text => {
      this.applySearchFilter(text);
    });

    this.getUserCustomers();
  }

  switchSection(sectionId: 'customers' | 'staff-list' | 'add-staff') {
    if (this.isStaff && sectionId !== 'customers') {
      return;
    }
    this.activeSection = sectionId;
    if (sectionId === 'add-staff') {
      this.editingStaffId = null;
      localStorage.removeItem('createdUser');
    }
  }

  onEditStaff(staffId: number) {
    if (this.isStaff) return;
    this.editingStaffId = staffId;
    this.activeSection = 'add-staff';
  }

  onShowAccessControl(staffId: number) {
    if (this.isStaff) return;
    this.accessControlStaffId = staffId;
    this.activeSection = 'access-control';
  }

  onBackToStaffList() {
    this.activeSection = 'staff-list';
    this.accessControlStaffId = null;
  }

  applySearchFilter(searchText: string) {
    const text = (searchText || '').trim().toLowerCase();
    if (!text) {
      this.userCustomerList = [...this.fullCustomerList];
      return;
    }

    this.userCustomerList = this.fullCustomerList.filter(c =>
      String(c.name ?? '').toLowerCase().includes(text) ||
      String(c.mobilenumber ?? '').toLowerCase().includes(text) ||
      String(c.email ?? '').toLowerCase().includes(text) ||
      String(c.gstnumber ?? '').toLowerCase().includes(text)
    );
  }

  tabs = [
    { id: 'personal', label: 'Personal Information' },
    { id: 'financial', label: 'Financial Information' },
    { id: 'address', label: 'Address Details' },
    { id: 'other', label: 'Other Information' },
  ];

  selectTab(index: number) {
    this.activeTab = index;
    localStorage.setItem('addCustomerTab', index.toString());
  }

  getUserCustomers() {
    let params = new HttpParams();
    if (this.selectedCustomerType) {
      params = params.append('user_customer_type', this.selectedCustomerType);
    }

    this.userCustomerService.getUserCustomers(params).subscribe({
      next: (res: any) => {
        this.fullCustomerList = res.data || [];
        this.applySearchFilter(this.userSearchService.getSearchText());
        this.isLoadingCustomers = false;
      },
      error: (err: any) => {
        console.error('Error:', err);
        this.isLoadingCustomers = false;
      }
    });
  }

  onCustomerTypeChange() {
    this.getUserCustomers();
  }

  onCustomerCardClick(customer: Customer) {
    const mappedType = customer.user_customer_type === 'Retailer' ? 'Retailer' : 'Direct';
    this.router.navigate(['/invoice-gst-panel'], {
      queryParams: {
        customer_id: customer.id,
        customer_type: mappedType,
      }
    });
  }

  onDelete(id: number) {
    this.userCustomerService.deleteUserCustomer(id).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess('Customer Deleted Successfully', 'Success');
        this.getUserCustomers();
      },
      error: (err: any) => {
        console.error('Error deleting user customer:', err);
      }
    });
  }
}
